import { useRoutes } from 'react-router-dom';
import router from 'src/router/router';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from './contexts/AuthContext';
import authRoutes from './router/auth-router';
import { ChatProvider } from './contexts/ChatContext';
import { ForwardProvider } from './contexts/ForwardContext';
import { SearchProvider } from './contexts/SearchContext';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

function App() {
  const content = useRoutes(router);
  const authContent = useRoutes(authRoutes);
  const { isAuth, user } = useContext(AuthContext);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ChatProvider>
          <SearchProvider>
            <ForwardProvider>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <CssBaseline />
                {isAuth && user?.role_id === 1 && content}
                {(!isAuth || user?.role_id !== 1) && authContent}
                     {/* {isAuth && content}
                     {(!isAuth) && authContent} */}
              </LocalizationProvider>
            </ForwardProvider>
          </SearchProvider>
        </ChatProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
export default App;
